import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, BLACK_900, Button, CardTitle, Collapsible, Divider, getTestId, isLastItem, isValidObject, LILAC_400, TRANSPARENT, Typography } from '@airtel/air-design-system';
import { Fragment, useState } from 'react';
import { Image, View } from 'react-native';
import { DescriptionWidgetComponent } from '../../../description-widget/DescriptionWidget';
import { DynamicScrollListWidget } from '../../../dynamic-scroll-list-widget';
import { ListWidget } from '../../../list-widget';
import { OrderSummaryCardWidget } from '../../../order-summary-card-widget';
import { ScrollLinkListWidget } from '../../../scroll-link-list-widget';
import { TableWidget } from '../../../table-widget';
import { getAccordionListWidgetStyles } from '../../AccordionListWidgetStyles';
export var DataList = props => {
  var data = props.data,
    isLevel2 = props.isLevel2,
    parentIndex = props.parentIndex,
    _props$collapsiblePro = props.collapsibleProps,
    collapsibleProps = _props$collapsiblePro === void 0 ? {} : _props$collapsiblePro,
    _props$autoCollapse = props.autoCollapse,
    autoCollapse = _props$autoCollapse === void 0 ? true : _props$autoCollapse,
    testID = props.testID,
    onUserAction = props.onUserAction,
    _props$showDivider = props.showDivider,
    showDivider = _props$showDivider === void 0 ? false : _props$showDivider,
    _props$hasSubTitle = props.hasSubTitle,
    hasSubTitle = _props$hasSubTitle === void 0 ? false : _props$hasSubTitle,
    viewAllButtonOnPressMetaData = props.viewAllButtonOnPressMetaData,
    viewAllButtonProps = props.viewAllButtonProps,
    dividerProps = props.dividerProps,
    _props$descriptionWid = props.descriptionWidgetProps,
    descriptionWidgetProps = _props$descriptionWid === void 0 ? {} : _props$descriptionWid,
    _props$showViewAllCta = props.showViewAllCtaButton,
    showViewAllCtaButton = _props$showViewAllCta === void 0 ? false : _props$showViewAllCta,
    showListSubtitleSection = props.showListSubtitleSection,
    listTitleSectionProps = props.listTitleSectionProps,
    collapseAll = props.collapseAll,
    selectedAccordion = props.selectedAccordion,
    initialItemsCount = props.initialItemsCount,
    itemCount = props.itemCount;
  var _useState = useState(TRANSPARENT),
    placeholderBgColor = _useState[0],
    setPlaceholderBgColor = _useState[1];
  var accordionListWidgetStyles = getAccordionListWidgetStyles();
  var slicedCount = initialItemsCount > 0 ? itemCount : data === null || data === void 0 ? void 0 : data.length;
  return _jsx(_Fragment, {
    children: data === null || data === void 0 ? void 0 : data.map((item, index) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
      var isNotLastItem = slicedCount ? index < slicedCount - 1 : !isLastItem(data, index);
      var _onPress = item.onPress,
        id = item.id,
        _item$isDynamicList = item.isDynamicList,
        isDynamicList = _item$isDynamicList === void 0 ? false : _item$isDynamicList,
        iconName = item.iconName,
        _item$isTableWidget = item.isTableWidget,
        isTableWidget = _item$isTableWidget === void 0 ? false : _item$isTableWidget,
        _item$level2Data = item.level2Data,
        level2Data = _item$level2Data === void 0 ? [] : _item$level2Data,
        expandedChildrenBgColor = item.expandedChildrenBgColor,
        expandedTitleContainerBgColor = item.expandedTitleContainerBgColor;
      var combineIndex = parentIndex + index;
      var hasLevel2Data = (level2Data === null || level2Data === void 0 ? void 0 : level2Data.length) > 0;
      var newTitle = typeof (item === null || item === void 0 ? void 0 : item.title) == 'string' && (item === null || item === void 0 ? void 0 : item.title);
      var newSubTitle = typeof (item === null || item === void 0 ? void 0 : item.subTitle) == 'string' && (item === null || item === void 0 ? void 0 : item.subTitle);
      var scrollLinkListProps = item === null || item === void 0 ? void 0 : item.scrollLinkListProps;
      var orderSummaryDynamicListProps = (_a = item === null || item === void 0 ? void 0 : item.content) === null || _a === void 0 ? void 0 : _a.orderSummaryDynamicListProps;
      var hasTitleComponent = ((_b = item === null || item === void 0 ? void 0 : item.iconUrl) === null || _b === void 0 ? void 0 : _b.length) > 0 || isValidObject(item === null || item === void 0 ? void 0 : item.title) || hasSubTitle || isValidObject(item === null || item === void 0 ? void 0 : item.subTitle);
      isValidObject(item === null || item === void 0 ? void 0 : item.bottomSubtitle);
      var isContentHiddenStyle = index >= slicedCount ? accordionListWidgetStyles.displayNone : '';
      var richText = (_c = item === null || item === void 0 ? void 0 : item.content) === null || _c === void 0 ? void 0 : _c.richText;
      return _jsxs(Fragment, {
        children: [_jsxs(Collapsible, Object.assign({
          style: isContentHiddenStyle
        }, collapsibleProps, getTestId(testID + ("_accordionList" + (isLevel2 ? '_level2' : '')), combineIndex), {
          isExpanded: isLevel2 ? (selectedAccordion === null || selectedAccordion === void 0 ? void 0 : selectedAccordion.level2) === "level2_" + combineIndex : (selectedAccordion === null || selectedAccordion === void 0 ? void 0 : selectedAccordion.level1) === "level1_" + combineIndex,
          iconSize: isLevel2 ? 'md' : 'xl',
          title: newTitle,
          subTitle: newSubTitle,
          prefixIconName: iconName,
          levelType: isLevel2 ? 'L2' : 'L1',
          expandedChildrenBgColor: expandedChildrenBgColor,
          expandedTitleContainerBgColor: expandedTitleContainerBgColor
        }, hasLevel2Data && {
          childPaddingToken: 'SPACING_0'
        }, {
          titleComponent: _jsx(_Fragment, {
            children: hasTitleComponent && _jsxs(View, Object.assign({
              style: accordionListWidgetStyles.titleComponent
            }, {
              children: [_jsx(View, Object.assign({
                style: accordionListWidgetStyles.titleComponentImage
              }, {
                children: ((_d = item === null || item === void 0 ? void 0 : item.iconUrl) === null || _d === void 0 ? void 0 : _d.length) > 0 && _jsx(Image, Object.assign({}, getTestId(testID, 'imageUrl'), {
                  source: {
                    uri: item === null || item === void 0 ? void 0 : item.iconUrl,
                    width: 25,
                    height: 25
                  },
                  style: Object.assign({
                    backgroundColor: placeholderBgColor
                  }, accordionListWidgetStyles.iconSpacer),
                  onError: () => setPlaceholderBgColor(LILAC_400)
                }))
              })), _jsxs(View, Object.assign({
                style: accordionListWidgetStyles.titleComponentText
              }, {
                children: [isValidObject(item === null || item === void 0 ? void 0 : item.title) && _jsx(_Fragment, {
                  children: hasSubTitle ? _jsx(CardTitle, Object.assign({}, getTestId(testID, 'subTitle'), {
                    title: (_e = item === null || item === void 0 ? void 0 : item.title) === null || _e === void 0 ? void 0 : _e.text,
                    subTitle: (_f = item === null || item === void 0 ? void 0 : item.subTitle) === null || _f === void 0 ? void 0 : _f.text,
                    showBulletSeperator: true,
                    style: accordionListWidgetStyles.adjustSize
                  })) : _jsx(Typography, Object.assign({
                    text: (_g = item === null || item === void 0 ? void 0 : item.title) === null || _g === void 0 ? void 0 : _g.text,
                    type: "body-para-md-bold",
                    color: BLACK_900,
                    fontSize: 16,
                    style: accordionListWidgetStyles.title
                  }, item.title, getTestId(testID, 'title')))
                }), isValidObject(item === null || item === void 0 ? void 0 : item.bottomSubtitle) && _jsx(Typography, Object.assign({
                  text: (_h = item === null || item === void 0 ? void 0 : item.bottomSubtitle) === null || _h === void 0 ? void 0 : _h.text,
                  type: "body-single-line-xs",
                  color: BLACK_700,
                  fontSize: 12,
                  style: accordionListWidgetStyles.safePadding
                }, item.bottomSubtitle, getTestId(testID, 'sub_title')))]
              }))]
            }))
          }),
          iconColor: BLACK_900,
          version: "variable-width",
          onPress: () => {
            var _a;
            autoCollapse && !((_a = item === null || item === void 0 ? void 0 : item.collapsibleProps) === null || _a === void 0 ? void 0 : _a.disableToggle) && collapseAll(combineIndex, isLevel2);
            _onPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
              id
            }, _onPress), {
              item,
              index,
              analyticsPosition: item === null || item === void 0 ? void 0 : item.analyticsPosition
            }));
          }
        }, item === null || item === void 0 ? void 0 : item.accessibilityProps, item === null || item === void 0 ? void 0 : item.collapsibleProps, isLevel2 && Object.assign(Object.assign({}, item === null || item === void 0 ? void 0 : item.collapsibleProps), {
          style: [(_j = item === null || item === void 0 ? void 0 : item.collapsibleProps) === null || _j === void 0 ? void 0 : _j.style, accordionListWidgetStyles.l2TitleSpacing],
          childPaddingToken: 'SPACING_0'
        }), {
          children: [!isDynamicList && ((_l = (_k = item === null || item === void 0 ? void 0 : item.content) === null || _k === void 0 ? void 0 : _k.dataArray) === null || _l === void 0 ? void 0 : _l.length) > 0 && _jsx(View, Object.assign({
            style: accordionListWidgetStyles.content
          }, {
            children: _jsx(ListWidget, Object.assign({
              showTitleSection: showListSubtitleSection,
              titleSectionProps: listTitleSectionProps,
              dataArray: (_m = item === null || item === void 0 ? void 0 : item.content) === null || _m === void 0 ? void 0 : _m.dataArray
            }, getTestId(testID, 'list')))
          })), isDynamicList && _jsx(DynamicScrollListWidget, Object.assign({}, getTestId(testID, 'dynamicList'), item === null || item === void 0 ? void 0 : item.content, {
            onUserAction: onUserAction
          })), isTableWidget && _jsx(TableWidget, Object.assign({}, getTestId(testID, 'table'), item === null || item === void 0 ? void 0 : item.content, {
            onUserAction: onUserAction
          })), isValidObject(orderSummaryDynamicListProps) && _jsx(OrderSummaryCardWidget, Object.assign({}, orderSummaryDynamicListProps, {
            onUserAction: onUserAction
          })), isValidObject(scrollLinkListProps) && _jsx(ScrollLinkListWidget, Object.assign({}, scrollLinkListProps, isLevel2 && {
            commonLinkListProps: Object.assign(Object.assign({}, scrollLinkListProps === null || scrollLinkListProps === void 0 ? void 0 : scrollLinkListProps.commonLinkListProps), {
              style: accordionListWidgetStyles.l2TitleSpacing
            })
          }, {
            onUserAction: onUserAction
          })), hasLevel2Data && _jsx(DataList, {
            data: level2Data,
            isLevel2: true,
            parentIndex: parentIndex,
            selectedAccordion: selectedAccordion,
            collapseAll: collapseAll,
            initialItemsCount: initialItemsCount,
            itemCount: itemCount,
            onUserAction: onUserAction
          }), showViewAllCtaButton && _jsx(Button, Object.assign({
            style: accordionListWidgetStyles.viewAllCtaButton,
            buttonType: "tertiary"
          }, viewAllButtonProps, getTestId(testID, 'viewAllCtaButton'), {
            onPress: () => {
              viewAllButtonOnPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
                id
              }, viewAllButtonOnPressMetaData), {
                item,
                index,
                analyticsPosition: item === null || item === void 0 ? void 0 : item.analyticsPosition
              }));
            }
          })), !!richText && _jsx(DescriptionWidgetComponent, Object.assign({
            id: "AccordianListDescriptionWidget",
            richText: richText
          }, descriptionWidgetProps))]
        })), (showDivider || isNotLastItem) && _jsx(Divider, Object.assign({}, dividerProps))]
      }, "accordion-list-" + combineIndex + "-" + index);
    })
  });
};